import React, { ForwardRefRenderFunction, InputHTMLAttributes, forwardRef } from 'react'
import cx from 'classnames'

import CheckImage from 'svgs/property-plan/check'

import styles from './Checkbox.module.scss'

const InnerCheckbox: ForwardRefRenderFunction<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>> = (
  { className, ...others },
  ref
) => {
  return (
    <div className={cx(styles.checkbox, className)}>
      <input type="checkbox" {...others} ref={ref} />
      <button type="button">
        <CheckImage className={styles.check} />
      </button>
    </div>
  )
}

const CheckBox = forwardRef(InnerCheckbox)

export default CheckBox
